import type { Theme } from '../../themes/ThemeTypes';

import auth from './auth/auth';
import base from './base';
import colors from './colors';
import alert from './components/alert';
import backgroundVariant from './components/backgroundVariant';
import buttons from './components/buttons';
import cards from './components/cards';
import forms from './components/forms';
import modal from './components/modal';
import navbar from './components/navbar';
import fonts from './fonts';
import icons from './icons';
import images from './images';
import language from './language.json';
import layout from './layout/layouts';
import standard from './layout/standard';
import links from './links.json';
import meta from './meta';
import overrides from './overrides';
import errorLabel from './ui/errorLabel';
import iconButton from './ui/iconButton';
import variables from './variables';

// UtilitaTheme interface is now the same as the Theme interface
export type UtilitaTheme = Theme;

const utilitaTheme: Theme = {
  base,
  colors,
  fonts,
  overrides,
  variables,
  buttons,
  alert,
  backgroundVariant,
  cards,
  forms,
  modal,
  navbar,
  standardLayout: standard,
  errorLabel,
  iconButton,
  auth,
  language,
  layout,
  meta,
  links,
  icons,
  images,
};

export { utilitaTheme };
